var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('icon-button',{staticClass:"ar-icon ar-icon__xs ar-icon--no-border",attrs:{"id":"download","name":"download"},nativeOn:{"click":function($event){return _vm.download.apply(null, arguments)}}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-655cb36e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/toefl/audio/components/downloader.vue
// module id = null
// module chunks = 